const Checkout = {
  billingPhoneInput: null,

  init() {
    this.billingPhoneInput = document.getElementById("billing_phone");

    if (this.billingPhoneInput) {
      this.bindEvents();
      Checkout.numberInput(this.billingPhoneInput, false);
    }
  },

  bindEvents() {
    this.billingPhoneInput.addEventListener("input", (e) => {
      Checkout.numberInput(e.target);
    });
  },

  numberInput(input, validateOnInit = true) {
    const inputError =
      input.parentElement.parentElement.querySelector(".field-error");

    // Remove non-digit characters
    let inputValue = input.value.replace(/\D/g, "");

    // Check if it contains '+370' or '370' and remove it
    if (inputValue.startsWith("370")) {
      inputValue = inputValue.slice(3);
    } else if (inputValue.startsWith("+370")) {
      inputValue = inputValue.slice(4);
    }

    // Only allow input starting with 5 or 6
    if (
      validateOnInit &&
      !inputValue.startsWith("5") &&
      !inputValue.startsWith("6")
    ) {
      inputValue = "";
      input.classList.add("error");
      inputError.classList.remove("d-none");
      inputError.textContent = "Telefono numeris neteisingas. Pradėkite nuo 6 arba 5";

      input.value = inputValue;
      return;
    }

    // Only allow 8 digits
    if (inputValue.length > 8) {
      inputValue = inputValue.slice(0, 8);

      input.classList.add("error");
      inputError.classList.remove("d-none");
      inputError.textContent = "Įveskite 8 skaičius";

      input.value = inputValue;
      return;
    }

    input.classList.remove("error");
    inputError.classList.add("d-none");
    inputError.textContent = "";

    // Update the input value
    input.value = inputValue;
  },
};

export default Checkout;
